

export default {
  name: 'UIFormItem',
  functional: true,
  props: {
    title: String,
    instructions: String,
    required: Boolean,
    error: Boolean,
    errorMsg: String,
    root: Boolean,
  },
  render (h, ctx) {
    const getSlot = 'scopedSlots' in ctx ? (name) => ctx.scopedSlots[name] && ctx.scopedSlots[name]() : (name) => ctx.slots()[name]; // for backward compat : some Vue version might not have this API available
    const els = [
      ...(ctx.props.title || getSlot('title')
        ? [
          h('span', { ...ctx.data, staticClass: 'label' }, (
            (ctx.props.required)
              ? [
                h('span', getSlot('title') || ctx.props.title),
                h('span', { staticClass: 'required' }, '*'),
              ]
              : getSlot('title') || ctx.props.title
          )),
        ]
        : []
      ),
      ...(ctx.children || []),
      ...(ctx.props.error && ctx.props.errorMsg
        ? [h('small', { ...ctx.data, staticClass: 'error' }, ctx.props.errorMsg)]
        : []
      ),
      ...(ctx.props.instructions || getSlot('instructions')
        ? [h('small', { ...ctx.data, staticClass: 'instructions' }, getSlot('instructions') || ctx.props.instructions)]
        : []
      ),
    ];
    let vnode = els;
    if (ctx.props.root) vnode = h('div', ctx.data, els);
    return vnode;
  },
};
